import { Link } from 'react-router-dom'

import ZriveLogoWhite from '../../../assets/bloom-logo-white.svg?react'
import { LangSwitcher } from '../i18n'
import { useI18N } from '../../../libraries/i18n/hook'
import config from '../../../config'

const Footer = () => {
  const { t } = useI18N()
  return (
    <div className='mt-6 md:pb-4 bg-transparent'>
      <div className='text-center flex flex-col-reverse md:flex md:flex-row items-center justify-between bg-deep-green py-8 md:py-4 px-6 md:rounded-full w-full'>
        <ZriveLogoWhite className='w-24 mt-6 md:mt-0 md:mb-0' />
        <nav className='flex flex-col items-center gap-y-6 md:inline-flex md:flex-row gap-x-8 text-sm text-white'>
          <LangSwitcher />
          <Link to='/internal-offers-faqs'>{t('menu.internalOffersFaqs')}</Link>
          <a
            href='https://cdn.prod.website-files.com/62a72c66bdbb662e04ea13e9/670d2399b1327c58e0d9deab_Poli%CC%81tica%20de%20cookies%20Zrive%20Web.pdf'
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('menu.cookiePolicy')}
          </a>
          <a
            href='https://cdn.prod.website-files.com/62a72c66bdbb662e04ea13e9/669e566e529edb35f252074e_Poli%CC%81tica%20de%20Privacidad%20Zrive%20Web.pdf'
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('menu.privacyPolicy')}
          </a>
          {config.VITE_APP_VERSION && (<small>{config.VITE_APP_VERSION}</small>)}
        </nav>
      </div>
    </div>
  )
}

export default Footer
